import { render, staticRenderFns } from "./TaskNewReportDetail.vue?vue&type=template&id=77d9dd56&scoped=true"
import script from "./TaskNewReportDetail.vue?vue&type=script&lang=js"
export * from "./TaskNewReportDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d9dd56",
  null
  
)

export default component.exports